import * as React from "react";
import { forwardRef } from "react";
const SvgCard2 = ({
  title,
  titleId,
  ...props
}, ref) => <svg viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<rect width={32} height={20} rx={4} fill="currentColor" /><rect x={6} y={6} width={20} height={2} rx={1} fill="white" /></svg>;
const ForwardRef = forwardRef(SvgCard2);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMiIgaGVpZ2h0PSIyMCIgcng9IjQiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSI2IiB5PSI2IiB3aWR0aD0iMjAiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";